import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import './SessionConfirmation.scss';

function SessionConfirmation({
  isOpen,
  toggle,
  pendingCloseOffcanvas,
  setPendingCloseOffcanvas,
  setNewCalibrationForm,
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="modal-session-confirmation"
      modalClassName="custom-modal-size"
      centered
      backdrop="static"
      keyboard={false}
      onClosed={() => {
        document.body.classList.remove('modal-open', 'offcanvas-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';

        if (pendingCloseOffcanvas) {
          setPendingCloseOffcanvas(false);
          setNewCalibrationForm(false);
        }
      }}
      unmountOnClose
    >
      <ModalHeader
        style={{ fontSize: '18px', fontWeight: '600' }}
        toggle={toggle}
      >
        Confirmation
      </ModalHeader>
      <ModalBody style={{ fontSize: '14px', fontWeight: '400' }}>
        Are you sure you want to cancel this session?
      </ModalBody>
      <ModalFooter className="modalFooter">
        <Button className="item custom-light-btn" onClick={() => toggle('no')}>
          No
        </Button>
        <Button className="item custom-btn" onClick={() => toggle('yes')}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default SessionConfirmation;
